export default {
    created () {

    },

    data() {
        return {

        }
    },

    methods: {
        toggleYoutubeVideoPopup (videoId, width, height) {
            this.toggleVideoDOMNode(this.generateYoutubeVideoFrameHtmlElement(videoId, width, height));
        },
        toggleVideoDOMNode(iframe) {
            var videoDOMNode = document.getElementById('video_player');
            if(videoDOMNode) videoDOMNode.remove();
            else {
                var videoPlayer = document.createElement("div"); 
                videoPlayer.id = "video_player";
                videoPlayer.classList.add('video_player--open');
                videoPlayer.addEventListener("click", this.toggleVideoDOMNode.bind(null), false);
                videoPlayer.appendChild(iframe);
                document.body.appendChild(videoPlayer);
            }
        },
        generateYoutubeVideoFrameHtmlElement(videoId, width, height) {
            var videoFrameSize = this.calculateFrameSize(width || 1, height || 1);
            var iframe = document.createElement("iframe");     
            iframe.setAttribute("src", encodeURI("https://www.youtube.com/embed/" + videoId));
            iframe.setAttribute("width", videoFrameSize.width);            
            iframe.setAttribute("height", videoFrameSize.height);
            iframe.setAttribute("frameborder", 0);
            iframe.setAttribute("allowFullScreen", "true");
            return iframe;
        },        
        calculateFrameSize(videoWidth, videoHeight) {
            const VIEWPORT_MARGIN = 0.25;
            var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            var maxFrameWidth = Math.min(viewportWidth * (1 - VIEWPORT_MARGIN), videoWidth);
            var maxFrameHeight = Math.min(viewportHeight * (1 - VIEWPORT_MARGIN), videoHeight);
            var biggestBoundReduction = Math.max(videoWidth / maxFrameWidth, videoHeight / maxFrameHeight);
            var adjustedWidth = Math.round(videoWidth / biggestBoundReduction);
            var adjustedHeight = Math.round(videoHeight / biggestBoundReduction);
            return { width: adjustedWidth, height: adjustedHeight };
        },
    }
}